import React, { useEffect, useState } from 'react';
import { Menu } from 'antd';
import useFilterState from '../../../hooks/useFilterState';
import DescriptionDropdown from '../../DescriptionDropdown/DescriptionDropdown';
import styles from '../InnerPageHeader.module.scss';

const StatusesDropdown = ({ filter, items = new Map(), description }) => {
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [selectedKeys, setSelectedKeys] = useState([]);

  const [filterState, setFilterState] = useFilterState(filter);

  const handleStatusesVisibleChange = (visible) => setDropdownVisible(visible);

  const handleStatusesMenuClick = ({ item }) => {
    const value = item.props.value;
    setFilterState(value);
    setDropdownVisible(false);
  };

  const overlay = (
    <Menu onClick={handleStatusesMenuClick} selectedKeys={selectedKeys}>
      {Array.from(items.values()).map((item) => (
        <Menu.Item key={item.key} value={item.value}>
          {item.text}
        </Menu.Item>
      ))}
    </Menu>
  );

  useEffect(() => {
    let selectedKeys = [];

    const item = items.get(filterState.join());

    if (item) {
      selectedKeys = [item.key];
    }

    setSelectedKeys(selectedKeys);
  }, [filterState]);

  const btnText = items.get(filterState.join())?.text ?? 'Не определено';

  return (
    <DescriptionDropdown
      description={description}
      dropdownProps={{
        onVisibleChange: handleStatusesVisibleChange,
        visible: dropdownVisible,
        overlay,
      }}
      buttonProps={{
        text: btnText,
        className: styles.statusesDropdown,
      }}
    />
  );
};

export default StatusesDropdown;
